import React, { useCallback } from 'react';

import { Box } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import ActionButton from 'components/action-button';
import Modal, { ModalContent } from 'components/modal';
import { useUIContext } from 'state/ui';

const ActionButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  :first-of-type button {
    margin-bottom: 1rem;
  }
  min-width: 268px;
`;

const MessageText = styled.p`
  font-size: 1.375rem;
  font-family: ${Styles.fontFamily.base};
  text-align: center;
`;

const MessageHeading = styled.h1`
  font-family: ${Styles.fontFamily.base};
  text-align: center;
`;

const WelcomeMessage = () => {
  const { formatMessage } = useIntl();
  const { isShowingWelcomeMessage, hideWelcomeMessage } = useUIContext();

  const handleSignBackIn = useCallback(() => {
    hideWelcomeMessage();
  }, [hideWelcomeMessage]);

  const handleDismiss = useCallback(() => {
    hideWelcomeMessage();
  }, [hideWelcomeMessage]);
  if (!isShowingWelcomeMessage) {
    return null;
  }

  const modalHeading = formatMessage({ id: 'legacyImportWelcomeMessageHeader' });
  const modalBody = formatMessage({ id: 'legacyImportWelcomeMessageText' });

  return (
    <Modal onDismiss={handleDismiss}>
      <ModalContent>
        <MessageHeading id="modal-heading" className="modal-heading">
          {modalHeading}
        </MessageHeading>
        <MessageText>{modalBody}</MessageText>
        <ActionButtonContainer>
          <Box margin="0.5rem">
            <ActionButton
              disabled={false}
              data-testid="welcome-message-sign-in"
              onClick={handleSignBackIn}
            >
              {formatMessage({ id: 'signIn' })}
            </ActionButton>
          </Box>
        </ActionButtonContainer>
      </ModalContent>
    </Modal>
  );
};

export default WelcomeMessage;
